import { render, staticRenderFns } from "./MarkdownContents.vue?vue&type=template&id=3ba2cfe4&scoped=true"
import script from "./MarkdownContents.vue?vue&type=script&lang=js"
export * from "./MarkdownContents.vue?vue&type=script&lang=js"
import style0 from "./MarkdownContents.vue?vue&type=style&index=0&id=3ba2cfe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba2cfe4",
  null
  
)

export default component.exports